import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./Surface.module.css";

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  variant?: "raised" | "sunken" | "canvas";
  padding?: 8 | 12 | 16 | 24;
  radius?: "sm" | "md" | "lg";
}

export function Surface({
  children,
  className,
  variant = "raised",
  padding = 16,
  radius = "md",
  ...rest
}: SurfaceProps) {
  return (
    <div
      className={cn(
        styles.surface,
        variant === "raised" && styles.raised,
        variant === "sunken" && styles.sunken,
        variant === "canvas" && styles.canvas,
        padding === 8 && styles.padding8,
        padding === 12 && styles.padding12,
        padding === 16 && styles.padding16,
        padding === 24 && styles.padding24,
        radius === "sm" && styles.radiusSm,
        radius === "md" && styles.radiusMd,
        radius === "lg" && styles.radiusLg,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
